import { Dialog } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ActionType, StakeMethod } from 'api/betslipAnalytics.api';
import { GreenCheckMarkIcon } from 'assets/icons';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DialogCard from 'shared/components/dialog/dialogCard';
import Button from 'shared/components/form/button';
import { SectionNavigation } from 'shared/constants/common';
import { BetslipEvents, setDataLayer } from 'shared/constants/datalayer';
import { useBetslipAnalytics } from 'shared/hooks/useBetslipAnalytics';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { isMobile } from 'shared/util/utility';
import { BETSType, CouponState, State } from '../../../../shared/interface';
import { getAnalyticalData } from '../../../../shared/util/analytical';
import './styles.scss';

interface PlaceBetSuccessDialogProps {
	betStatics: any;
	onCloseCongratsModal: () => void;
	deleteBets: () => void;
	setStakeMethod: (stake: string) => void;
	bets: BETSType;
}

const PlaceBetSuccessDialog = (props: PlaceBetSuccessDialogProps) => {
	const { t } = useTranslation();
	const { addAction } = useBetslipAnalytics();
	const location = useLocation();
	const [betStatics] = useState(props.betStatics);
	const { changeNavigationView } = useSectionNavigation();
	const betslipWinAmount = betStatics?.newPossibleWinning?.totalWinning ?? 0;
	const coupon = useSelector<State, CouponState>((state) => state.coupon);

	const handleDelete = () => {
		props.deleteBets();
		props.onCloseCongratsModal();
		setDataLayer(BetslipEvents.BET_FINISHED(getAnalyticalData(coupon)));
		if (isMobile()) {
			changeNavigationView(SectionNavigation.HOME);
		}
	};

	const handlePlayAgain = () => {
		props.bets.outcomes.forEach((item: any) => {
			const betObj = {
				outcomeId: item.outcomeId,
				outcomeOdds: item.odds,
				outcomeName: item.name,
				eventId: item.eventId,
				eventType: 1,
				gameName: item.gameName,
				gameId: item.gameId,
				eventName: item.eventName,
				league: `${item.sportName} / ${item.parentName} / ${item.categoryName}`,
				selectedBet: true,
				sportId: item.sportId,
				banker: false,
				isLive: item.isLive,
			};
			addAction(betObj, location.pathname, ActionType.ADD);
		});
		props.onCloseCongratsModal();
		setDataLayer(BetslipEvents.BET_AGAIN(getAnalyticalData(coupon)));
		props.setStakeMethod(StakeMethod.LAST);
	};

	return (
		<>
			<Dialog
				maxWidth="xs"
				fullWidth
				onClose={() => {}}
				className="custom-dialog bg--transparent custom--box-shadow text--center"
				aria-labelledby="customized-dialog"
				open={true}
			>
				<DialogCard
					className="success--card PlaceBetSuccessDialog"
					icon={() => <GreenCheckMarkIcon className="modal--icon lock--icon" />}
					iconTitle={() => <div dangerouslySetInnerHTML={{ __html: t('betsArePlaced') }} />}
					subDescription={`${t('possibleWinnings')}`}
					title={betslipWinAmount}
					showAmount={true}
					cardBottomCustom={
						<div className="card__bottom card__bottom_multi-btn">
							<Button btnType="dialog-success-cancel" onClick={handlePlayAgain} cyTestRef="betslip-play-again">
								{t('playAgain')}
							</Button>
							<Button btnType="dialog-success-accept" cyTestRef="yes-button" onClick={handleDelete}>
								{t('ok')}
							</Button>
						</div>
					}
				/>
			</Dialog>
		</>
	);
};

export default PlaceBetSuccessDialog;
